import { useEffect, useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'

type scrollPosition = {
  y: number
  path: string
}
const scrollPositions: scrollPosition[] = []

export const useKeepScrollPosition = () => {
  const { pathname: currentPathName } = useLocation()

  useLayoutEffect(() => {
    const scrollPosition = scrollPositions.find(
      (position) => position.path === currentPathName
    )

    if (scrollPosition) {
      window.scrollTo({ top: scrollPosition.y })
    } else {
      window.scrollTo({ top: window.scrollY + 1 })
    }

    const handleScroll = () => {
      const y = window.scrollY
      const existingPosition = scrollPositions.find(
        (position) => position.path === currentPathName
      )

      if (existingPosition) {
        existingPosition.y = y
      } else {
        scrollPositions.push({ y, path: currentPathName })
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [currentPathName])
}
